import { render, staticRenderFns } from "./ReplacementSummary.vue?vue&type=template&id=5f543542&"
import script from "./ReplacementSummary.vue?vue&type=script&lang=js&"
export * from "./ReplacementSummary.vue?vue&type=script&lang=js&"
import style0 from "./ReplacementSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports